/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：203
 */

"use strict"

function r(e) {
  return (r = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e)
  })(e)
}
export { r as a }
export default r
